export default {
  'menu.cms.site.website': '網站設定',
  'menu.cms.site.sitemap': 'Sitemap',
  'menu.cms.site.robots': 'Robots',
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '設置',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.cms.content': '內容資產',
  'menu.cms.content.all': '全部內容',
  'menu.cms.content.review': '審核列表',
  'menu.cms.content.categories': '分類管理',
  'menu.cms.content.tags': '標籤管理',
  'menu.cms.content.categories.master': '內容母本',
  'menu.cms.content.categories.product': '產品內容',
  'menu.cms.content.categories.solution': '解決方案',
  'menu.cms.content.categories.case': '客戶案例',
  'menu.cms.content.categories.article': '文章與觀點',
  'menu.cms.content.categories.faq': 'FAQ與術語',
  'menu.cms.content.categories.channel': '渠道版本',
  'menu.cms.content.categories.archive': '內容歸檔',
  'menu.cms.content.material': '素材中心',
  'menu.cms.ai.topic': 'AI選題',
  'menu.account': '個人頁',
  'menu.cms.site.publication': '發布記錄',
  'menu.cms.site.list': '站點列表',
  'menu.cms.site.categories': '分類列表',
  'menu.cms.site.analytics': '站長統計',
  'menu.cms.settings.forms': '表單管理',
  'menu.cms.settings.submissions': '提交記錄',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
